module.exports = __webpack_public_path__ + "static/media/logo_cardio.c51fdb4f.jpeg";